import React, { useEffect, useState } from 'react';
import {
  CreateCampaignCommissionOverride,
  GetAllCampaignOverrides,
} from '../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { showError } from '../../../../../Helper';
import {
  CampaignConfigurationFields,
  CampaignConfigurationTable,
} from './Components';
import { PlusIcon } from '../../../../../assets/icons';
import InfoNoticeBox from '../../Utilities/InfoNoticeBox';
import { Spinner } from '../../../../../Components';
import FieldWithLabel from '../../../../../Components/FieldWithLabel/FieldWithLabel';
import infoPoints from './Components/infoPoints';

export default function CampaignConfiguration({
  translate,
  parentTranslationPath,
  entitySources,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [campaignOverrides, setCampaignOverrides] = useState([]);
  const [state, setState] = useState({
    campaignCommissionOverrideId: null,
    leadXchangeEntitySourceId: null,
    commissionType: null,
    commissionValue: null,
  });

  const [selectedValue, setSelectedValue] = useState({
    entitySource: null,
    commissionType: null,
    commissionValue: '',
    campaignOverrides: null,
  });

  const getAllCampaignOverrides = async () => {
    setIsLoading(true);
    try {
      const result = await GetAllCampaignOverrides();
      setCampaignOverrides(result);
    } catch {
      showError('Failed to fetch campaign configuration.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateCampaignCommissionOverride = async () => {
    try {
      await CreateCampaignCommissionOverride(state);
      reload();
    } catch (error) {
      showError(
        error.response.data[0] || 'Failed to create entity commission setting.'
      );
    }
  };

  const reload = () => {
    setState({
      leadXchangeEntitySourceId: null,
      campaignName: null,
      commissionType: null,
      commissionValue: null,
    });
    setSelectedValue({
      entitySource: {},
      commissionType: null,
      commissionValue: '',
      campaignOverrides: {},
    });
    getAllCampaignOverrides();
  };

  useEffect(() => {
    getAllCampaignOverrides();
  }, []);
  return (
    <div className='leadxchange-config-container'>
      <div className='leadxchange-card-wrapper'>
        <Spinner isActive={isLoading} />

        <div className='leadxchange-card-header'>
          <div className='leadxchange-card-header-wrapper'>
            <span>{translate('Campaign configuration')}</span>
          </div>
          <span className='field_divider'></span>
        </div>
        <div className='leadxchange-card-content'>
          <CampaignConfigurationFields
            parentTranslationPath={parentTranslationPath}
            translate={translate}
            entitySources={entitySources}
            campaignOverrides={campaignOverrides}
            state={state}
            setState={setState}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
          />
          <FieldWithLabel
            hideDivider
            component={
              <div className='leadxchange-data'>
                <button
                  onClick={handleCreateCampaignCommissionOverride}
                  className='add-another-wrapper'
                >
                  <PlusIcon
                    width='20'
                    height='20'
                    fill='#475467'
                  />
                  <span className='add-another'>
                    {translate('add_another')}
                  </span>
                </button>
                <CampaignConfigurationTable
                  parentTranslationPath={parentTranslationPath}
                  translate={translate}
                  campaignOverrides={campaignOverrides}
                  setState={setState}
                  state={state}
                  selectedValue={selectedValue}
                  setSelectedValue={setSelectedValue}
                  setCampaignOverrides={setCampaignOverrides}
                  reload={reload}
                  entitySources={entitySources}
                />
              </div>
            }
          />
        </div>
      </div>
      <InfoNoticeBox
        infoTitle={'How Campaign Commission Overrides Work'}
        infoPoints={infoPoints}
        translate={translate}
      />
    </div>
  );
}
